var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mx-2 mx-md-4 mx-3 payment" },
    [
      _c("div", { staticClass: "bg-white border-radius--light py-2" }, [
        _c("div", { staticClass: "row" }, [
          _vm._m(0),
          _c("div", { staticClass: "col-md-12" }, [
            _c("div", { staticClass: "bg-secondary-9 rounded p-md-3 p-2" }, [
              _c("div", { staticClass: "row bg-white m-1 p-3 rounded" }, [
                _c(
                  "div",
                  { staticClass: "col-6 col-md-2" },
                  [
                    _c("total-amount-view", {
                      staticClass: "payment__total-amount-view",
                      attrs: {
                        amount: _vm.getAmount(_vm.value.totalAttendedAmt),
                        "amount-class": _vm.amountClass(
                          _vm.value.totalAttendedAmt
                        ),
                        icon: "fa fa-usd-circle",
                        "icon-color": "color-yellow-star",
                        title: "Subtotal de Asistencias:"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6 col-md-2" },
                  [
                    _c("total-amount-view", {
                      staticClass: "payment__total-amount-view",
                      attrs: {
                        amount: _vm.getAmount(
                          _vm.value.previousYearAdjustmentAmt
                        ),
                        "amount-class": _vm.amountClass(
                          _vm.value.previousYearAdjustmentAmt
                        ),
                        icon: "fa fa-usd-circle",
                        "icon-color": "color-secondary-16",
                        title: "Ajuste Automático Año Previo:"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6 col-md-2" },
                  [
                    _c("total-amount-view", {
                      staticClass: "payment__total-amount-view",
                      attrs: {
                        amount: _vm.getAmount(_vm.value.automaticAdjustmenAmt),
                        "amount-class": _vm.amountClass(
                          _vm.value.automaticAdjustmenAmt
                        ),
                        icon: "fa fa-usd-circle",
                        "icon-color": "color-secondary-30",
                        title: "Total de Ajuste Automático:"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6 col-md-2" },
                  [
                    _c("total-amount-view", {
                      staticClass: "payment__total-amount-view",
                      attrs: {
                        amount: _vm.getAmount(_vm.value.manualAdjustmentAmt),
                        "amount-class": _vm.amountClass(
                          _vm.value.manualAdjustmentAmt
                        ),
                        icon: "fa fa-usd-circle",
                        "icon-color": "color-secondary-30",
                        title: "Total de Ajuste Manual:"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "payment__total-to-pay col-md-2 border-left d-flex justify-content-end"
                  },
                  [
                    _c("total-amount-view", {
                      staticClass: "payment__total-amount-view",
                      attrs: {
                        amount: _vm.getAmount(_vm.value.costTotalAmt),
                        "amount-class": "font-22 color-secondary-31",
                        icon: "fa fa-usd-circle",
                        "icon-color": "color-secondary-25",
                        title: "Total a pagar:"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "div",
                {
                  staticClass: "payment__footer-days row pr-0 pt-3 ml-md-4 ml-2"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "payment__footer-days col-md-3 col-4 pl-md-5"
                    },
                    [
                      _c("div", [
                        _c(
                          "span",
                          {
                            staticClass:
                              "payment__footer-days__label font-14 font-weight-normal color-secondary-6"
                          },
                          [_vm._v(" Número de Jornal: ")]
                        ),
                        _c(
                          "p",
                          {
                            staticClass:
                              "payment__footer-days__date font-16 font-weight-normal color-black font-weight-bold"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.status !=
                                    _vm.assistanceApprovalStatus.Denegado &&
                                    _vm.value.paymentJournalNumber != null
                                    ? _vm.value.paymentJournalNumber
                                    : "-"
                                ) +
                                " "
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "payment__footer-days col-md-3 col-3" },
                    [
                      _c("div", [
                        _c(
                          "span",
                          {
                            staticClass:
                              "payment__footer-days__label font-14 font-weight-normal color-secondary-6"
                          },
                          [_vm._v(" Fecha de pago: ")]
                        ),
                        _c(
                          "p",
                          {
                            staticClass:
                              "payment__footer-days__date font-16 font-weight-normal color-black font-weight-bold"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.status !=
                                    _vm.assistanceApprovalStatus.Denegado
                                    ? _vm.getDate(_vm.value.paymentDate)
                                    : "-"
                                ) +
                                " "
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-md-6 col-4 px-0 px-md-3 d-flex justify-content-end"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "payment__footer-days__card bg-white rounded p-3 w-25 d-flex flex-column justify-content-center align-items-center m-1"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "payment__footer-days__label color-gray-6 font-14 font-weight-bold"
                            },
                            [_vm._v(" Cumplimiento de Pago: ")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "badge badge-pill badge-primary p-md-2",
                              class: {
                                "bg-secondary-32":
                                  _vm.value.daysForPaymentStatusCode ===
                                    _vm.daysForPaymentStatusEnum.Normal ||
                                  _vm.value.daysForPaymentStatusCode ===
                                    _vm.daysForPaymentStatusEnum.Unset,
                                "bg-green":
                                  _vm.value.daysForPaymentStatusCode ===
                                  _vm.daysForPaymentStatusEnum.Good,
                                "bg-primary-17":
                                  _vm.value.daysForPaymentStatusCode ===
                                  _vm.daysForPaymentStatusEnum.Exceeded
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "payment__footer-days__date font-14 font-weight-bold mx-2"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.value.daysForPayment !== null
                                          ? _vm.value.daysForPayment + " días "
                                          : "-"
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ])
      ]),
      _c("payment-additional-list", {
        staticClass: "my-4",
        attrs: { items: _vm.additionalPayments },
        on: {
          "on-delete": function($event) {
            return _vm.$emit("on-delete", $event)
          }
        }
      }),
      _c("payment-relationship-list", {
        staticClass: "my-4",
        attrs: { "payment-journal": _vm.value, value: _vm.paymentRelationship },
        on: {
          "on-delete-relation": function($event) {
            return _vm.$emit("on-delete-relation", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-2 mb-3" }, [
      _c("em", { staticClass: "fas fa-file-invoice-dollar text-orange mr-2" }),
      _c("span", [_vm._v("Detalles de Pago")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }